import React, { useEffect, useRef, useState } from "react";
import "./ReportMessages.scss";
import { AgingReport, AgingReportBalance, AgingReportMessage, toMonthYear, toPrettyCurrency, toPrettyDate } from "common";
import Select from 'react-select';
import { useUser } from "../store";
import { notify } from "../util/notify";
import ReportMessage from "./ReportMessage";
import { useReports } from "../store/reports";
import { useForm, SubmitHandler, Controller } from "react-hook-form"



type ResponseType = {
  id: number;
  text: string;
  sentAt: string;
  deadline?: string;
  recipients: string[];
};

type Thread = {
  id: number;
  text: string;
  sentAt: string;
  deadline?: string;
  targetMonths: string[];
  collapsed: boolean;
  responses: ResponseType[];
};



export default function ReportMessages({ report, onCancel }: { report: AgingReport, onCancel: () => void }) {
  const { invokeApi } = useUser();
  const {
    updateReport,
  } = useReports();


  const [users, setUsers] = useState<any[]>([]);
  const [updatedReport, setUpdatedReport] = useState<AgingReport>(report);

  type Inputs = {
    message: string,
    deadline: string,
    months: string[],
    recipients: string[],
  }

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    setFocus,
    formState: { errors },
  } = useForm<Inputs>()



  useEffect(() => {
    invokeApi({ endpoint: "/getUsersForNonAdmins" }).then((data: any) => {
      setUsers(data);
    });
  }, []);

  const refreshReport = (report: AgingReport) => {
    setUpdatedReport(report);
    updateReport(report);
  }

  const onSubmit = (input: Inputs) => {
    const { message, deadline, recipients, months } = input;
    const toValues = (entries: any[]) => entries?.map(e => e.value) || [];
    const data = { 
      message, 
      deadline, 
      recipients: toValues(recipients), 
      months: toValues(months), 
      residentName: updatedReport.residentName, 
      billType: updatedReport.billType, 
      index: updatedReport.index
    };

    invokeApi({
      endpoint: "/putReportMessage",
      data,
    }).then((report: AgingReport) => {
      refreshReport(report);
      reset({message: "", deadline: "", recipients: [], months: []});
      setFocus("message");
      notify.success("Message added!");
    });
  };






  const monthOptions: any[] = [];
  if (updatedReport?.balances) {
    Object.entries(updatedReport.balances)?.forEach(([month, balance]) => {
      const { history, paid } = balance as AgingReportBalance;
      if (history?.[0] === 0) return;
      monthOptions.push({
        value: month,
        label: toMonthYear(month)
      });
    });
  }

  const onReply = (months: string[]) => {
    const newMonths = months.map(m => monthOptions.find(o => o.value === m));
    setFocus("message");
    setValue("months", newMonths);
  }

  return (
    <div className="chat-container">
      <div className="chat-header has-background-info">
        <div>
          <div className="title">{updatedReport.residentName} <i className="fa-solid fa-xmark" onClick={onCancel}></i></div>
        </div>
      </div>

      <div className="chat-body">
        {!(updatedReport?.messages?.length) && <div className="no-messages">No messages yet...</div>}
        {updatedReport?.messages?.map((message, index) =>
          <ReportMessage {...(index === updatedReport.messages.length - 1 ? { autoFocus: true } : {})} key={message.id} message={message} parentReport={report} onReply={onReply} refreshReport={refreshReport} />
        )}
      </div>

      <div className="chat-input">
        <textarea
          className={errors.message && "is-danger"}
          autoFocus
          placeholder="Type your message..."
          {...register("message", { required: true })}
        />

        <div className="input-row">
          <input
            type="date"
            {...register("deadline")}
          />
          <Controller
            name="recipients"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Recipients"
                menuPlacement="top"
                isMulti="true"
                options={users?.map((u: any) => ({ value: u?.username, label: u?.name }))}
              />
            )}
          />
          <Controller
            name="months"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Months"
                menuPlacement="top"
                isMulti="true"
                options={monthOptions}
              />
            )}
          />

          <span className="move-right">
            <button className="cancel-btn" onClick={onCancel}>
              Cancel
            </button>
            <button className="send-btn" onClick={handleSubmit(onSubmit)}>
              Send
            </button>
          </span>
        </div>
      </div>
    </div>
  );
};

